module.exports = __webpack_public_path__ + "img/scroll.ab3dc6b5.svg";